import React, { useEffect } from "react";

import { Button } from "@/components/Form";
import Sharing, { SharingType } from "@/components/Sharing";
import { LocaleProps, withLocale } from "@/i18n";

import {
  ButtonWrap,
  ContentBox,
  Image,
  Section,
  SharingWrap,
  Text,
  Title,
  Wrapper,
} from "./styles";

export type ScoreProps = {
  range?: string;
  text?: string;
  image?: string;
  icons: IIcons;
  handleShareClick: (type: SharingType) => void;
  showRetry?: boolean;
  onRetry?: () => void;
  onLoad: () => void;
} & LocaleProps;

const Score: React.FC<ScoreProps> = (props: ScoreProps): JSX.Element => {
  useEffect(() => {
    setTimeout(() => props.onLoad(), 4000);
  }, []);

  return (
    <Section>
      <Wrapper>
        <ContentBox>
          <Title>
            {props.range} {props.i18n?.score.title}
          </Title>
          <Text>{props.text}</Text>
          {props.image && (
            <Image src={props.image} showOnlyImage={!props.text} />
          )}
          {props.showRetry && (
            <ButtonWrap>
              <Button data-qa="score:retry:btn" onClick={props.onRetry}>
                {props.i18n?.score.retry}
              </Button>
            </ButtonWrap>
          )}
          <SharingWrap>
            <Sharing
              icons={props.icons}
              onShareClick={props.handleShareClick}
            />
          </SharingWrap>
        </ContentBox>
      </Wrapper>
    </Section>
  );
};

export default withLocale(Score);
